export interface Department {
  name: string;
  activationCode: string;
}

export interface BusinessConfig {
  id: number;
  name: string;
  subdomain: string;
  departments: Department[];
}

export const businesses: BusinessConfig[] = [
  {
    id: 12,
    name: 'Teck Quebrada Blanca',
    subdomain: 'qb',
    departments: [
      { name: 'Default', activationCode: 'TC-D3D' },
      { name: 'Operación Mina', activationCode: 'TC-OB7' },
      { name: 'Planta', activationCode: 'TC-PB8' },
      { name: 'Administrativo', activationCode: 'TC-AB9' },
      { name: 'Otro', activationCode: 'TC-OBA' },
    ],
  },
  {
    id: 13,
    name: 'Otros Quebrada Blanca',
    subdomain: 'qb',
    departments: [
      { name: 'Default', activationCode: 'OD-D3E' },
      { name: 'Test', activationCode: 'OD-T183' },
    ],
  },
  {
    id: 35,
    name: 'Multi X - Chaparano',
    subdomain: 'multix',
    departments: [
      { name: '[CC] Administración', activationCode: 'M23-[EA' },
      { name: '[CC] Operarios Producción', activationCode: 'M23-[ED' },
      { name: '[CC] Técnico en Mantención', activationCode: 'M23-[EF' },
      { name: '[CC] Auxiliar Cocina', activationCode: 'M23-[EB' },
      { name: '[CC] Información Mensual', activationCode: 'M23-[EC' },
      { name: '[CC] Otros', activationCode: 'M23-[EE' },
    ],
  },
  {
    id: 6,
    name: 'Ultraport - Arica',
    subdomain: 'ultraport',
    departments: [
      { name: '[CC] Administrativo', activationCode: 'U6-[23' },
      { name: '[CC] Documental', activationCode: 'U6-[25' },
      { name: '[CC] Mecánico', activationCode: 'U6-[27' },
      { name: '[CC] Movilizador', activationCode: 'U6-[28' },
      { name: '[CC] Operador', activationCode: 'U6-[29' },
      { name: '[CC] Coordinación', activationCode: 'U6-[24' },
      { name: '[CC] Supervisor o Capataz', activationCode: 'U6-[2A' },
      { name: '[CC] General u otros', activationCode: 'U6-[20' },
      { name: 'Mantenimiento', activationCode: 'U6-M17C' },
      { name: 'Supervisores Operaciones', activationCode: 'U6-S17D' },
      { name: 'HSE', activationCode: 'U6-H17E' },
      { name: 'Bodega', activationCode: 'U6-B17F' },
    ],
  },
  {
    id: 1,
    name: 'Makana SPA',
    subdomain: 'register',
    departments: [{ name: 'Demo', activationCode: 'M1-D2C' }],
  },
  {
    id: 11,
    name: 'Aramark Quebrada Blanca',
    subdomain: 'qb',
    departments: [
      { name: 'Default', activationCode: 'AB-D3C' },
      { name: '[CC] Otros', activationCode: 'AB-[44' },
      { name: '[CC] Staff', activationCode: 'AB-[43' },
      { name: '[CC] Retail', activationCode: 'AB-[42' },
      { name: '[CC] Mantención menor', activationCode: 'AB-[41' },
      { name: '[CC] Alimentación', activationCode: 'AB-[3F' },
      { name: '[CC] Aseo y Hotelería', activationCode: 'AB-[40' },
    ],
  },
  {
    id: 63,
    name: 'Ultraport - Valparaiso',
    subdomain: 'ultraport',
    departments: [
      { name: 'Administrativo Faena', activationCode: 'U3F-A15C' },
      { name: 'Administrativo Sucursal', activationCode: 'U3F-A15D' },
      { name: 'Auxiliar de Fierro', activationCode: 'U3F-A15E' },
      { name: 'Auxiliar de Fruta', activationCode: 'U3F-A15F' },
      { name: 'Movilizador Fruta', activationCode: 'U3F-M160' },
      { name: 'Movilizador Aforo', activationCode: 'U3F-M161' },
      { name: 'Trincador Fierro', activationCode: 'U3F-T162' },
      { name: 'Trincador a bordo', activationCode: 'U3F-T163' },
      { name: 'Trincador Estación de piña/Muelle', activationCode: 'U3F-T164' },
      { name: 'Operador de grúa pórtico', activationCode: 'U3F-O165' },
      { name: 'Operador de grúa RTG', activationCode: 'U3F-O166' },
      { name: 'Operador de NAVE', activationCode: 'U3F-O167' },
      { name: 'Operador de grúa Gottwald', activationCode: 'U3F-O168' },
      { name: 'Operador de grúa Horquilla', activationCode: 'U3F-O169' },
      { name: 'Operador Portacontenedores', activationCode: 'U3F-O16A' },
      { name: 'Operador Tractocamión', activationCode: 'U3F-O16B' },
      { name: 'Portalonero, Personal de tránsito', activationCode: 'U3F-P16C' },
      { name: 'Uto Gate', activationCode: 'U3F-U16D' },
      { name: 'Encargado Gate', activationCode: 'U3F-E16E' },
      { name: 'Carpintero', activationCode: 'U3F-C16F' },
      { name: 'Internación de información', activationCode: 'U3F-I170' },
      { name: 'Capataz', activationCode: 'U3F-C171' },
      { name: 'Encargado de Faena', activationCode: 'U3F-E172' },
      { name: 'Jefe de Nave', activationCode: 'U3F-J173' },
    ],
  },
  {
    id: 64,
    name: 'Saval',
    subdomain: 'saval',
    departments: [{ name: 'Gerencia RRHH', activationCode: 'S40-G174' }],
  },
  {
    id: 28,
    name: 'Ultraport - Angamos',
    subdomain: 'ultraport',
    departments: [
      { name: '[CC] Supervisor', activationCode: 'U1C-[D5' },
      { name: '[CC] Documental', activationCode: 'U1C-[BD' },
      { name: '[CC] Capataz', activationCode: 'U1C-[BC' },
      { name: '[CC] Movilizador', activationCode: 'U1C-[BE' },
      { name: '[CC] Operador', activationCode: 'U1C-[C0' },
      { name: '[CC] Otros', activationCode: 'U1C-[BB' },
      { name: '[CC] Dirigente', activationCode: 'U1C-[D3' },
      { name: '[CC] Oficinista', activationCode: 'U1C-[D6' },
    ],
  },
  {
    id: 29,
    name: 'Ultraport - Mejillones',
    subdomain: 'ultraport',
    departments: [
      { name: '[CC] Operaciones graneles líquidos', activationCode: 'U1D-[CD' },
      { name: '[CC] Administración', activationCode: 'U1D-[C9' },
      { name: '[CC] Otros', activationCode: 'U1D-[D0' },
      { name: '[CC] Eventuales', activationCode: 'U1D-[CB' },
      { name: '[CC] Mantención', activationCode: 'U1D-[CA' },
      { name: '[CC] Operaciones concentrado', activationCode: 'U1D-[CC' },
      { name: '[CC] Operaciones graneles sólidos', activationCode: 'U1D-[CE' },
      { name: '[CC] Puerto Mejillones', activationCode: 'U1D-[D1' },
    ],
  },
  {
    id: 16,
    name: 'MOWI Chacabuco',
    subdomain: 'mowi',
    departments: [
      { name: 'Otros', activationCode: 'M10-O72' },
      { name: '[CC] Acopio', activationCode: 'M10-[64' },
      { name: '[CC] Eviscerado', activationCode: 'M10-[66' },
      { name: '[CC] HON', activationCode: 'M10-[67' },
      { name: '[CC] Secundaria', activationCode: 'M10-[68' },
      { name: '[CC] Calidad', activationCode: 'M10-[69' },
      { name: '[CC] Mantención', activationCode: 'M10-[6E' },
      { name: '[CC] Administración y otros', activationCode: 'M10-[6F' },
      { name: '[CC] Riles', activationCode: 'M10-[70' },
      { name: '[CC] Frigorífico', activationCode: 'M10-[71' },
      { name: '[CC] Primaria', activationCode: 'M10-[65' },
      { name: '[CC] Bodega', activationCode: 'M10-[74' },
      { name: '[CC] Salud y SSO', activationCode: 'M10-[6A' },
      { name: '[CC] Empaque', activationCode: 'M10-[6B' },
      { name: '[CC] Valor Agregado', activationCode: 'M10-[6C' },
      { name: '[CC] Limpieza y Aseo', activationCode: 'M10-[6D' },
    ],
  },
  {
    id: 8,
    name: 'Humboldt',
    subdomain: 'humboldt',
    departments: [
      { name: '[CC] Administración', activationCode: 'H8-[39' },
      { name: '[CC] Cubierta', activationCode: 'H8-[2E' },
      { name: '[CC] Máquinas', activationCode: 'H8-[32' },
      { name: '[CC] Cámara', activationCode: 'H8-[36' },
      { name: '[CC] Otros', activationCode: 'H8-[F5' },
    ],
  },
  {
    id: 47,
    name: 'AquaChile - Planta Chonchi',
    subdomain: 'aguachirle',
    departments: [
      { name: 'EMPAQUE', activationCode: 'A2F-E102' },
      { name: 'CALIDAD', activationCode: 'A2F-C104' },
      { name: 'MANTENCIÓN', activationCode: 'A2F-M105' },
      { name: 'JEFE TURNO', activationCode: 'A2F-J10B' },
      { name: 'HIGENE', activationCode: 'A2F-H10C' },
      { name: '[CC] Default', activationCode: 'A2F-[FD' },
      { name: 'HG', activationCode: 'A2F-H100' },
      { name: 'CONTROL PRODUCCION', activationCode: 'A2F-C103' },
      { name: 'FRIGORIFICO', activationCode: 'A2F-F108' },
      { name: 'YAL', activationCode: 'A2F-Y10A' },
      { name: 'FILETE', activationCode: 'A2F-F101' },
      { name: 'ACOPIO', activationCode: 'A2F-A106' },
      { name: 'PATIO', activationCode: 'A2F-P107' },
      { name: 'BODEGA', activationCode: 'A2F-B109' },
      { name: 'Prueba del register', activationCode: 'A2F-P182' },
    ],
  },
  {
    id: 50,
    name: 'DP World',
    subdomain: 'dpworld',
    departments: [
      { name: 'Default', activationCode: 'D32-D10D' },
      { name: 'Encargado', activationCode: 'D32-E10F' },
      { name: 'Gerente', activationCode: 'D32-G111' },
      { name: 'Administrativo', activationCode: 'D32-A10E' },
      { name: 'Estibador', activationCode: 'D32-E110' },
      { name: 'Jefe', activationCode: 'D32-J112' },
      { name: 'Movilizador', activationCode: 'D32-M115' },
      { name: 'Operador de Equipo', activationCode: 'D32-O116' },
      { name: 'Supervisor', activationCode: 'D32-S117' },
      { name: 'Mantención: Eléctrico', activationCode: 'D32-M113' },
      { name: 'Mantención: Mecánico', activationCode: 'D32-M114' },
    ],
  },
  {
    id: 55,
    name: 'Forvis Mazars',
    subdomain: 'forvismazars',
    departments: [
      { name: 'Audit', activationCode: 'F37-A12E' },
      { name: 'Tax & Legal', activationCode: 'F37-T12F' },
      { name: 'AOS', activationCode: 'F37-A130' },
      { name: 'FAS', activationCode: 'F37-F131' },
      { name: 'Servicios Generales', activationCode: 'F37-S132' },
      { name: 'Consultoría', activationCode: 'F37-C133' },
      { name: 'Otros', activationCode: 'F37-O134' },
    ],
  },
  {
    id: 61,
    name: 'MOWI Chonchi',
    subdomain: 'mowi',
    departments: [
      { name: 'ROC XR', activationCode: 'M3D-R175' },
      { name: 'ROC XIR', activationCode: 'M3D-R176' },
      { name: 'SSO', activationCode: 'M3D-S177' },
      { name: 'Operaciones', activationCode: 'M3D-O178' },
      { name: 'Sustentabilidad', activationCode: 'M3D-S179' },
      { name: 'Medio Ambiente', activationCode: 'M3D-M17A' },
      { name: 'Chinquihue', activationCode: 'M3D-C17B' },
      { name: 'Producción', activationCode: 'M3D-P180' },
      { name: 'Comunicaciones', activationCode: 'M3D-C181' },
    ],
  },
  {
    id: 60,
    name: 'Marsh',
    subdomain: 'marsh',
    departments: [{ name: 'Default', activationCode: 'M3C-D15A' }],
  },
  {
    id: 15,
    name: 'Sura',
    subdomain: 'sura',
    departments: [
      {
        name: 'GERENCIA REGIONAL SERVICIOS DE ASEGURAMIENTO',
        activationCode: 'SF-G4E',
      },
      { name: 'COMUNICACIONES Y CULTURA', activationCode: 'SF-C4F' },
      {
        name: 'DISEÑO ORGANIZACIONAL, COMPENSACIONES Y EXPERIENCIA DEL COLABORADOR',
        activationCode: 'SF-D50',
      },
      { name: 'OPERACIONES & CONTROL GESTION TH', activationCode: 'SF-O51' },
      { name: 'GERENCIA LEGAL', activationCode: 'SF-G52' },
      { name: 'PRESIDENCIA', activationCode: 'SF-P54' },
      {
        name: 'CAPACIDAD DE COMPETITIVIDAD EMPRESARIAL',
        activationCode: 'SF-C57',
      },
      { name: 'NEGOCIOS CORPORATIVOS', activationCode: 'SF-N59' },
      {
        name: 'GERENCIA DE NEGOCIOS EMPRESAS Y PERSONAS',
        activationCode: 'SF-G5A',
      },
      { name: 'MARKETING Y TRANSFORMACION DIGITAL', activationCode: 'SF-M5B' },
      { name: 'GERENCIA DE FINANZAS', activationCode: 'SF-G5C' },
      { name: '[CC] Otros', activationCode: 'SF-[4C' },
      { name: 'ADMINISTRACION', activationCode: 'SF-A56' },
      { name: 'VICEPRESIDENCIA DE SEGUROS', activationCode: 'SF-V55' },
      { name: 'RIESGOS FINANCIEROS', activationCode: 'SF-R58' },
      {
        name: 'PRESTACIONES MOVILIDAD AUTONOMIA Y SALUD',
        activationCode: 'SF-P53',
      },
      {
        name: 'GERENCIA DE NUEVOS MODELOS DE NEGOCIO Y DESARROLLO DE MERCADOS',
        activationCode: 'SF-G5E',
      },
      {
        name: 'GERENCIA DE SERVICIOS OPERACIONALES Y EXPERIENCIA DE CLIENTES',
        activationCode: 'SF-G5F',
      },
      { name: 'CONTROL GESTION', activationCode: 'SF-C61' },
      { name: '[CC] Dirección y Estrategia', activationCode: 'SF-[D8' },
      { name: '[CC] Negocios y Comercial', activationCode: 'SF-[DA' },
      { name: '[CC] Personas y Cultura', activationCode: 'SF-[DC' },
      { name: '[CC] Tecnología', activationCode: 'SF-[60' },
      { name: 'VICEPRESIDENCIA DE TALENTO HUMANO', activationCode: 'SF-V5D' },
      {
        name: 'VICEPRESIDENCIA DE FINANZAS Y GESTION DE INFORMACION',
        activationCode: 'SF-V63',
      },
      { name: 'PROYECTO CORE', activationCode: 'SF-P62' },
      { name: '[CC] Finanzas y Riesgo', activationCode: 'SF-[D9' },
      {
        name: '[CC] Operaciones y Servicio al cliente',
        activationCode: 'SF-[DB',
      },
    ],
  },
  {
    id: 66,
    name: 'Itaú',
    subdomain: 'itau',
    departments: [
      { name: 'Piso 2', activationCode: 'I42-P184' },
      { name: 'Piso 6', activationCode: 'I42-P185' },
      { name: 'Piso 7', activationCode: 'I42-P186' },
      { name: 'Piso 8', activationCode: 'I42-P187' },
      { name: 'Piso 9', activationCode: 'I42-P188' },
      { name: 'Piso 10', activationCode: 'I42-P189' },
      { name: 'Piso 11', activationCode: 'I42-P18A' },
      { name: 'Piso 12', activationCode: 'I42-P18B' },
      { name: 'Piso 13', activationCode: 'I42-P18C' },
      { name: 'Piso 14', activationCode: 'I42-P18D' },
      { name: 'Piso 15', activationCode: 'I42-P18E' },
      { name: 'Piso 16', activationCode: 'I42-P18F' },
      { name: 'Piso 17', activationCode: 'I42-P190' },
      { name: 'Piso 18', activationCode: 'I42-P191' },
      { name: 'Piso 4', activationCode: 'I42-P1AE' },
      { name: 'Piso -1', activationCode: 'I42-P1AD' },
    ],
  },
  {
    id: 65,
    name: 'Domino´s Pizza',
    subdomain: 'dominos',
    departments: [
      { name: 'Finanzas', activationCode: 'D41-F192' },
      { name: 'Marketing', activationCode: 'D41-M193' },
      { name: 'TI', activationCode: 'D41-T194' },
      { name: 'Gestión de Personas', activationCode: 'D41-G195' },
      { name: 'Operaciones', activationCode: 'D41-O196' },
      { name: 'Commissary', activationCode: 'D41-C197' },
      { name: 'Compras', activationCode: 'D41-C1B0' },
      { name: 'Mantención', activationCode: 'D41-M1B1' },
      { name: 'Calidad', activationCode: 'D41-C1B2' },
    ],
  },
  {
    id: 68,
    name: 'SAAM',
    subdomain: 'saam',
    departments: [
      { name: 'Default', activationCode: 'S44-D198' },
      { name: 'San Vicente', activationCode: 'S44-S199' },
      { name: 'Valparaiso', activationCode: 'S44-V19A' },
      { name: 'Mejillones', activationCode: 'S44-M19B' },
      { name: 'Antofagasta', activationCode: 'S44-A19C' },
      { name: 'Quintero', activationCode: 'S44-Q19D' },
      { name: 'San Antonio', activationCode: 'S44-S19E' },
    ],
  },
  {
    id: 67,
    name: 'Sandvik',
    subdomain: 'sandvik',
    departments: [
      { name: 'Default', activationCode: 'S43-D19F' },
      { name: 'Warehouse', activationCode: 'S43-W1A1' },
      { name: 'Workshop', activationCode: 'S43-W1A2' },
      { name: 'Compras', activationCode: 'S43-C1A3' },
      { name: 'Field Service', activationCode: 'S43-F1A4' },
      { name: 'RRHH', activationCode: 'S43-R1A5' },
      { name: 'Parts & Service', activationCode: 'S43-P1A6' },
      { name: 'Finanzas', activationCode: 'S43-F1A7' },
      { name: 'EHS', activationCode: 'S43-E1A8' },
      { name: 'Otros', activationCode: 'S43-O1A9' },
      { name: 'Rock Tools', activationCode: 'S43-R1AA' },
      { name: 'Marketing Professional', activationCode: 'S43-M1AB' },
      { name: 'Automation', activationCode: 'S43-A1AC' },
    ],
  },
  {
    id: 69,
    name: 'Makana Individual',
    subdomain: '',
    departments: [{ name: 'General', activationCode: 'M45-G1A0' }],
  },
  {
    id: 70,
    name: 'Falabella',
    subdomain: 'falabella',
    departments: [
      { name: 'Catedral', activationCode: 'F46-C1AF' },
      { name: 'Auditoria Interna De Retail', activationCode: 'F46-A1B3' },
      { name: 'B2b Corp', activationCode: 'F46-B1B4' },
      { name: 'Back Office Bi', activationCode: 'F46-B1B5' },
      { name: 'Control De Gestión Corp', activationCode: 'F46-C1B6' },
      { name: 'Bunker Comercial', activationCode: 'F46-B1B7' },
      { name: 'Calidad Y Reporting', activationCode: 'F46-C1B8' },
      { name: 'Campañas Ecommerce', activationCode: 'F46-C1B9' },
      { name: 'Cdc Ventas', activationCode: 'F46-C1BA' },
      { name: 'Click & Collect Corp', activationCode: 'F46-C1BB' },
      { name: 'Comercial Corp', activationCode: 'F46-C1BC' },
      { name: 'Control De Gestión Corp.', activationCode: 'F46-C1BD' },
      { name: 'Control De Gestion Operacional', activationCode: 'F46-C1BE' },
      { name: 'Control Interno Corporativo', activationCode: 'F46-C1BF' },
      { name: 'Control Interno Tradis', activationCode: 'F46-C1C0' },
      { name: 'Departamento De Compensaciones', activationCode: 'F46-D1C1' },
      { name: 'Depto. Catedral. Bienestar', activationCode: 'F46-D1C2' },
      { name: 'Depto. De Pago A Proveedores', activationCode: 'F46-D1C3' },
      { name: 'Depto. Comunicaciones', activationCode: 'F46-D1C4' },
      { name: 'Depto. Control Interno Ecommerce', activationCode: 'F46-D1C5' },
      { name: 'Depto. De Gestion', activationCode: 'F46-D1C6' },
      { name: 'Diseño Ecommerce', activationCode: 'F46-D1C7' },
      { name: 'Diseño Jeans', activationCode: 'F46-D1C8' },
      { name: 'Diseño Mujer', activationCode: 'F46-D1C9' },
      { name: 'Division Tiendas Depto. Chile', activationCode: 'F46-D1CA' },
      { name: 'Edicion Informacion Producto', activationCode: 'F46-E1CB' },
      { name: 'Estudio Multimedia', activationCode: 'F46-E1CC' },
      { name: 'Falabella Connect', activationCode: 'F46-F1CD' },
      { name: 'Falabella Media', activationCode: 'F46-F1CE' },
      { name: 'Finanzas', activationCode: 'F46-F1CF' },
      { name: 'Finanzas Ecommerce', activationCode: 'F46-F1D0' },
      { name: 'Fotografia Estudio Multimedia', activationCode: 'F46-F1D1' },
      { name: 'Gcia Calzado Retail Corp', activationCode: 'F46-G1D2' },
      { name: 'Gcia Damas Retail Corp', activationCode: 'F46-G1D3' },
      { name: 'Gcia Deco Retail Corp', activationCode: 'F46-G1D4' },
      { name: 'Gcia Electro Retail Corp', activationCode: 'F46-G1D5' },
      { name: 'Gcia Hombres Retail Corp', activationCode: 'F46-G1D6' },
      { name: 'Gcia Niños Retail Corp', activationCode: 'F46-G1D7' },
      { name: 'Gcia Deporte E Infantil Ecommerce', activationCode: 'F46-G1D8' },
      { name: 'Gcia Ecommerce Belleza', activationCode: 'F46-G1D9' },
      { name: 'Gcia Ecommerce Deco', activationCode: 'F46-G1DA' },
      { name: 'Gcia Ecommerce Vestuari', activationCode: 'F46-G1DB' },
      { name: 'Gcia Ecommerce Vestuario', activationCode: 'F46-G1DC' },
      { name: 'Gcia Flexit', activationCode: 'F46-G1DD' },
      { name: 'Gcia Onsite Experience', activationCode: 'F46-G1DE' },
      {
        name: 'Gcia Seguridad Y Prevencion De Perdidas',
        activationCode: 'F46-G1DF',
      },
      { name: 'Gcia. Electrónica', activationCode: 'F46-G1E0' },
      { name: 'Gcia. Linea Belleza', activationCode: 'F46-G1E1' },
      { name: 'Gcia. Vestuario Damas', activationCode: 'F46-G1E2' },
      { name: 'Gerencia Comercial', activationCode: 'F46-G1E3' },
      { name: 'Gerencia Marketing', activationCode: 'F46-G1E4' },
      { name: 'Gerencia Store Planning', activationCode: 'F46-G1E5' },
      { name: 'Gerencia Visual Merchandising', activationCode: 'F46-G1E6' },
      { name: 'Gerencia Bi Corp', activationCode: 'F46-G1E7' },
      { name: 'Gerencia Control Y Medioambiente', activationCode: 'F46-G1E8' },
      {
        name: 'Gerencia Corporativa Linea Belleza',
        activationCode: 'F46-G1E9',
      },
      { name: 'Gerencia De Control Interno', activationCode: 'F46-G1EA' },
      { name: 'Gerencia De Negocios', activationCode: 'F46-G1EB' },
      {
        name: 'Gerencia De Planif. De Merchandising',
        activationCode: 'F46-G1EC',
      },
      { name: 'Gerencia De Planning Corp', activationCode: 'F46-G1ED' },
      {
        name: 'Gerencia De Producto Y Estrategia Digital',
        activationCode: 'F46-G1EE',
      },
      { name: 'Gerencia De Recursos Humanos', activationCode: 'F46-G1EF' },
      { name: 'Gerencia Ecommerce', activationCode: 'F46-G1F0' },
      { name: 'Gerencia Estudio Multimedia', activationCode: 'F46-G1F1' },
      { name: 'Gerencia General', activationCode: 'F46-G1F2' },
      { name: 'Gerencia Innovación Y Metodologia', activationCode: 'F46-G1F3' },
      { name: 'Gerencia Linea Niños', activationCode: 'F46-G1F4' },
      { name: 'Gerencia Linea Calzados', activationCode: 'F46-G1F5' },
      { name: 'Gerencia Linea Decohogar', activationCode: 'F46-G1F6' },
      { name: 'Gerencia Linea Varones', activationCode: 'F46-G1F7' },
      { name: 'Gerencia Marca Americanino', activationCode: 'F46-G1F8' },
      { name: 'Gerencia Marcas Internacionales', activationCode: 'F46-G1F9' },
      { name: 'Gerencia Marketing Ecommerce', activationCode: 'F46-G1FA' },
      { name: 'Gerencia Operaciones', activationCode: 'F46-G1FB' },
      { name: 'Gerencia Operaciones Ecommerce', activationCode: 'F46-G1FC' },
      { name: 'Gerencia Sell-In', activationCode: 'F46-G1FD' },
      { name: 'Gerencia Venta A Empresas', activationCode: 'F46-G1FE' },
      { name: 'Gerencia Zonales', activationCode: 'F46-G1FF' },
      { name: 'Gerencias Centrales Independencia', activationCode: 'F46-G200' },
      { name: 'Inteligencia Comercial', activationCode: 'F46-I201' },
      { name: 'Línea Calzado Ecommerce', activationCode: 'F46-L202' },
      { name: 'Línea Electro Ecommerce', activationCode: 'F46-L203' },
      { name: 'Modelaje Jeans', activationCode: 'F46-M204' },
      { name: 'Modelaje Mujer', activationCode: 'F46-M205' },
      { name: 'Onsite Experience Regional', activationCode: 'F46-O206' },
      { name: 'Overhead Stand Alone', activationCode: 'F46-O207' },
      {
        name: 'Post Producción Estudio Multimedia',
        activationCode: 'F46-P208',
      },
      { name: 'Programadores Ti', activationCode: 'F46-P209' },
      { name: 'Proyectos Sac', activationCode: 'F46-P20A' },
      { name: 'Relacion Laborales', activationCode: 'F46-R20B' },
      {
        name: 'Responsabilidad Social Empresarial',
        activationCode: 'F46-R20C',
      },
      { name: 'Revenue Management', activationCode: 'F46-R20D' },
      { name: 'Rol Privado Dvd', activationCode: 'F46-R20E' },
      { name: 'Rol Privado Sac', activationCode: 'F46-R20F' },
      { name: 'Rol Privado Zonales Chile', activationCode: 'F46-R210' },
      { name: 'Rrhh Sac', activationCode: 'F46-R211' },
      { name: 'Sac De Tienda', activationCode: 'F46-S212' },
      { name: 'Sac Ecommerce', activationCode: 'F46-S213' },
      { name: 'Servicios Generales', activationCode: 'F46-S214' },
      { name: 'Servicios Otec', activationCode: 'F46-S215' },
      { name: 'Subg. Experiencia De Clientes', activationCode: 'F46-S216' },
      { name: 'Subg. Mejora Continua Y Prod.', activationCode: 'F46-S217' },
      { name: 'Subg. Operaciones Omnicanal', activationCode: 'F46-S218' },
      { name: 'Subg. Procesos Y Op. Tiendas', activationCode: 'F46-S219' },
      { name: 'Subgerencia Cdec Comercial', activationCode: 'F46-S21A' },
      {
        name: 'Subgerencia Continuidad Operacional Txd',
        activationCode: 'F46-S21B',
      },
      {
        name: 'Subgerencia De Desarrollo Organizacional',
        activationCode: 'F46-S21C',
      },
      { name: 'Subgerencia De Finanzas', activationCode: 'F46-S21D' },
      { name: 'Subgerencia De Rrhh', activationCode: 'F46-S21E' },
      {
        name: 'Subgerencia Ti Proyectos Operaciones',
        activationCode: 'F46-S21F',
      },
      { name: 'Unidad De Prevencion Del Delito', activationCode: 'F46-U220' },
      { name: 'Gerencia de Procurement & Energía', activationCode: 'F46-G221' },
      { name: 'Gerencia de Sostenibilidad', activationCode: 'F46-G222' },
    ],
  },
  {
    id: 71,
    name: 'Yáneken - Casa Matriz',
    subdomain: 'yaneken',
    departments: [
      { name: 'Gerencia de TI', activationCode: 'Y47-G223' },
      { name: 'Gerencia de Retail', activationCode: 'Y47-G224' },
      {
        name: 'Gerencia Administración y Finanzas',
        activationCode: 'Y47-G225',
      },
      { name: 'YNK Logística', activationCode: 'Y47-Y226' },
      { name: 'Gerencia Comercial', activationCode: 'Y47-G227' },
      { name: 'Gerencia de Operaciones', activationCode: 'Y47-G228' },
      {
        name: 'Gerencia de Planificación Marketing E/Commerce',
        activationCode: 'Y47-G229',
      },
      {
        name: 'Gerencia de Nuevas Categorías y Expansión',
        activationCode: 'Y47-G22A',
      },
      {
        name: 'Gerencia Tecnología y Abastecimiento',
        activationCode: 'Y47-G22B',
      },
      { name: 'Gerencia de Personas', activationCode: 'Y47-G22C' },
      { name: 'Gerencia General', activationCode: 'Y47-G22D' },
      {
        name: 'Gerencia de E/Commerce & Wholesale',
        activationCode: 'Y47-G22E',
      },
    ],
  },
  {
    id: 72,
    name: 'Yáneken - Centro de Distribución',
    subdomain: 'yaneken',
    departments: [
      { name: 'Administración Eco', activationCode: 'Y48-A22F' },
      { name: 'Administración Logística', activationCode: 'Y48-A230' },
      { name: 'Aseo', activationCode: 'Y48-A231' },
      { name: 'Auditoría', activationCode: 'Y48-A232' },
      { name: 'Aufbau', activationCode: 'Y48-A233' },
      { name: 'Despacho', activationCode: 'Y48-D234' },
      { name: 'Insumos', activationCode: 'Y48-I235' },
      { name: 'Logística inversa', activationCode: 'Y48-L236' },
      { name: 'Maquila', activationCode: 'Y48-M237' },
      { name: 'Operaciones', activationCode: 'Y48-O238' },
      { name: 'OSR', activationCode: 'Y48-O239' },
      { name: 'Producción Ecom', activationCode: 'Y48-P23A' },
      { name: 'Producción Logística', activationCode: 'Y48-P23B' },
      { name: 'Recepción y Almacenamiento', activationCode: 'Y48-R23C' },
      { name: 'Catálogo', activationCode: 'Y48-C23D' },
    ],
  },
];

export const resolveBusinesses = (hostname: string): BusinessConfig[] => {
  const parts = hostname.split('.');
  const sub = parts[0];
  return businesses.filter(b => b.subdomain === sub);
};

export const resolveBusiness = (
  hostname: string
): BusinessConfig | undefined => {
  return resolveBusinesses(hostname)[0];
};
